import { COMPARE_SORT_VIEW } from 'Common/enums';

function WithCompareSort(sortType?: string, chartTypeWiseSort?: SimulationPerformanceTableItem[]) {
    const sortData = chartTypeWiseSort?.length ? chartTypeWiseSort : [];
    switch (sortType?.toString()) {
        case COMPARE_SORT_VIEW.SANDBOX_HIGH:
            sortData?.sort((a, b) => Number(b?.matches) - Number(a?.matches));
            break;
        case COMPARE_SORT_VIEW.SANDBOX_LOW:
            sortData?.sort((a, b) => Number(a?.matches) - Number(b?.matches));
            break;
        case COMPARE_SORT_VIEW.DEPLOYED_HIGH:
            sortData?.sort((a, b) => Number(b?.performanceData?.matches) - Number(a?.performanceData?.matches));
            break;
        case COMPARE_SORT_VIEW.DEPLOYED_LOW:
            sortData?.sort((a, b) => Number(a?.performanceData?.matches) - Number(b?.performanceData?.matches));
            break;
        default:
            sortData?.sort((a: any, b: any) => a?.rule?.localeCompare(b?.rule, { numeric: true }));
            break;
    }
    return sortData;
}
export default WithCompareSort;
